import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/warning/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/warning/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/warning/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/warning/locales/da/messages.mjs';
import { messages as svMessages} from '../src/raw/warning/locales/sv/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages, svMessages);


export class IconWarning16 extends LitElement {
  render() {
      const title = i18n.t({ message: `Warning triangle with exclamation point`, id: 'icon.title.warning', comment: 'Title for warning icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-warning-16-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" d="m.712 14.07 6.25-12.994a1 1 0 0 1 1.792-.022l6.635 12.995a1 1 0 0 1-.89 1.455H1.613a1 1 0 0 1-.902-1.434Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 6v4.992M8 13v.333"></path></svg>`; }
}
if (!customElements.get('w-icon-warning-16')) {
  customElements.define('w-icon-warning-16', IconWarning16);
}